// material ui icons
import BoltIcon from '@mui/icons-material/Bolt';
import LocalFireDepartmentRoundedIcon from '@mui/icons-material/LocalFireDepartmentRounded';
import QuestionMarkRoundedIcon from '@mui/icons-material/QuestionMarkRounded';
import WaterDropRoundedIcon from '@mui/icons-material/WaterDropRounded';

export const getAnalysisTypeIcon = (analysisType) => {
  switch (analysisType) {
    case 'power':
      return <BoltIcon />;
    case 'water':
      return <WaterDropRoundedIcon />;
    case 'heat':
      return <LocalFireDepartmentRoundedIcon />;
    default:
      return <QuestionMarkRoundedIcon />;
  }
};
